import type {
    NeglectedOrDelinquentGEDModel,
} from './NeglectedOrDelinquentInformationModel';

export const GED_SECTIONS: {
    key: keyof NeglectedOrDelinquentGEDModel;
    description: string;
    totalLabel: string;
    totalField: 'gedEnrolledTotal' | 'gedEarnedTotal';
}[] = [
    {
        key: 'enrolledInGEDProgram',
        description: 'who enrolled in a GED Program:',
        totalLabel: 'Total Students Enrolled for GED',
        totalField: 'gedEnrolledTotal',
    },
    {
        key: 'earnedGED',
        description: 'who earned a GED:',
        totalLabel: 'Total Students Earned GED',
        totalField: 'gedEarnedTotal',
    },
];
